import { InjectionToken } from '@angular/core';
import { Env } from '../config/@env';

export const ENV = new InjectionToken<Env>('ENV');
